export default "__VITE_ASSET__D1jjtwov__"